import LayoutBasic from "@/views/layouts/LayoutBasic";
import telephonyCalls from "@/views/telephony/Calls";
import telephonyIpNumbers from "@/views/telephony/ipNumbers";
import telephonySip from "@/views/telephony/Sip";
import telephonyAccess from "@/views/telephony/access";
import MangoUsers from "@/views/telephony/MangoUsers";
import phoneCallsMissed from "@/views/phoneCalls/missed";
import newMissedCalls from "@/views/phoneCalls/missed_new";
import sendedSMS from '@/views/admin/sms/sendedSMS.vue'
import manageSMS from '@/views/admin/sms/manageSMS.vue'
import segmentsSMS from '@/views/admin/sms/segmentsSMS.vue'
import segmentSMS from '@/views/admin/sms/segmentSMS.vue'
import BankSMSList from '@/views/admin/sms/bankSMSList';
import BankPhones from "@/views/telephony/BankPhones";
import Statistics from "@/views/telephony/Statistics.vue";

const routes = [
  {
    path: '/telephony',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'calls',
        component: telephonyCalls,
        name: 'telephonyCalls',
        meta: {
          permission: 'telephony/calls'
        }
      },
      {
        path: 'list',
        component: telephonyIpNumbers,
        name: 'telephonyIpNumbers',
        meta: {
          permission: 'telephony/ipNumbers'
        }
      },
      {
        path: 'sip',
        component: telephonySip,
        name: 'telephonySip',
        meta: {
          permission: 'telephony/sip'
        }
      },
      {
        path: 'access',
        component: telephonyAccess,
        name: 'telephonyAccess',
        meta: {
          permission: 'telephony/access'
        }
      },
      {
        path: 'mangoUsers',
        component: MangoUsers,
        name: 'MangoUsers',
        meta: {
          permission: 'telephony/mangoUsers'
        }
      },
      {
        path: 'bank',
        component: BankPhones,
        name: 'BankPhones',
        meta: {
          permission: 'telephony/bank'
        }
      },
      {
        path: 'statistics',
        component: Statistics,
        name: 'telephonyStatistics',
        meta: {
          permission: 'telephony/statistics'
        }
      },
    ]
  },
  {
    path: '/sms',
    component: LayoutBasic,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'service',
        name: 'bankSMS',
        component: BankSMSList
      },
      {
        path: 'sended',
        name: 'sendedSMS',
        component: sendedSMS
      },
      {
        path: 'manage',
        name: 'manageSMS',
        component: manageSMS
      },
      {
        path: 'segments',
        name: 'segmentsSMS',
        component: segmentsSMS
      },
      {
        path: 'segment/:id?',
        name: 'segmentSMS',
        component: segmentSMS
      },
    ]
  },
  {
    path: '/phoneCalls',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'missed',
        name: 'phoneCallsMissed',
        component: phoneCallsMissed
      },
      {
        path: 'mmissed',
        name: 'newMissedCalls',
        component: newMissedCalls
      },
    ]
  }
]

export default routes;
